import { render, staticRenderFns } from "./SelectionGridList.vue?vue&type=template&id=d2c27052&scoped=true&"
import script from "./SelectionGridList.vue?vue&type=script&lang=js&"
export * from "./SelectionGridList.vue?vue&type=script&lang=js&"
import style0 from "./SelectionGridList.vue?vue&type=style&index=0&id=d2c27052&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2c27052",
  null
  
)

export default component.exports